(function () {
  var isMemorialDay = window.location.pathname.includes('/collections/memorial-day');
  // bbWK48PromoTag is injected by Liquid in the section template (one line per theme).
  var promoTag = window.bbWK48PromoTag;
  var tagCache = Object.create(null); // handle → true | false

  function getHandleFromCard(card) {
    var link = card.querySelector('.ns-details > a');
    if (!link) return null;
    var match = link.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function applyPromoPrice(card) {
    if (card.dataset.bbPromoApplied) return;

    var priceEl = card.querySelector('.ns-details .ns-price');
    if (!priceEl) return;

    var priceText = priceEl.textContent.trim();
    var match = priceText.match(/([\D]*)(\d+(?:\.\d+)?)(.*)/);
    if (!match) return;

    var prefix = match[1];
    var amount = parseFloat(match[2]);
    var suffix = match[3];
    var promoAmount = Math.round(amount / 2);

    // Case B: Nosto already shows a struck-through compare_at_price in the card —
    // keep that element untouched and just swap the current sale price for the promo price.
    // Case A: no existing strike-through — wrap current price in <s> and append promo price.
    var existingStrike = card.querySelector('.ns-list-price, .ns-original-price, s, del');

    // Disconnect observer before mutating the DOM so our changes don't re-trigger
    // Nosto's own MutationObserver and prevent its overlay campaigns from settling.
    observer.disconnect();
    if (existingStrike) {
      priceEl.textContent = prefix + promoAmount + suffix;
    } else {
      priceEl.innerHTML =
        '<s style="opacity:0.6">' + priceText + '</s>' +
        ' ' + prefix + promoAmount + suffix;
    }
    observer.observe(target, { childList: true, subtree: true });

    card.dataset.bbPromoApplied = '1';
  }

  function checkCard(card) {
    if (card.dataset.bbPromoApplied || card.dataset.bbPromoChecking) return;

    if (isMemorialDay) {
      applyPromoPrice(card);
      return;
    }

    if (!promoTag) return;

    var handle = getHandleFromCard(card);
    if (!handle) return;

    if (tagCache[handle] === true) { applyPromoPrice(card); return; }
    if (tagCache[handle] === false) return;

    // Fetch product JSON to check tags — result is CDN-cached by Shopify.
    card.dataset.bbPromoChecking = '1';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var isPromo = Array.isArray(data.tags) && data.tags.indexOf(promoTag) !== -1;
        tagCache[handle] = isPromo;
        if (isPromo) applyPromoPrice(card);
      })
      .catch(function () { tagCache[handle] = false; });
  }

  function processGrid() {
    document.querySelectorAll('#ns-product-grid .ns-product').forEach(checkCard);
  }

  // Only react when actual .ns-product nodes are added — not on every DOM mutation.
  // This prevents our price-text changes from triggering a feedback loop with
  // Nosto's own observer, which would block Nosto badge/banner injection.
  var target = document.querySelector('#ns-product-grid') || document.body;
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return (
          n.nodeType === 1 &&
          ((n.classList && n.classList.contains('ns-product')) ||
            (n.querySelector && n.querySelector('.ns-product')))
        );
      });
    });
    if (hasNewCards) processGrid();
  });
  observer.observe(target, { childList: true, subtree: true });

  // Attempt immediately in case Nosto already rendered before this script ran.
  processGrid();
})();
